import { Injectable } from '@angular/core';
import { PopoverController, ToastController } from '@ionic/angular';
import { ProductInfoComponent } from 'src/app/components/preparazione-ordini/preparazione-ordini-detaggli/product-info/product-info.component';
import { Orders } from 'src/app/models/Orders.model';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  constructor(
    private toastController: ToastController,
    private popoverCtrl: PopoverController
  ) {}

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 1500,
      position: 'top',
    });

    await toast.present();
  }

  async presentProductsInfo(orderId: number) {
    const popover = await this.popoverCtrl.create({
      component: ProductInfoComponent,
      componentProps: { orderId },
      cssClass: 'center-text product-list-popover',
    });

    await popover.present();

    return await popover.onDidDismiss();
  }
}
